export default "__VITE_ASSET__021aac88__"